const hasCheckedOption = () => {
  return !!document.querySelector("[name='vending_cart_id']:checked")
}

const toggleSubmitButton = () => {
  const submit = document.querySelector("[type='submit']")
  submit.disabled = hasCheckedOption() === false
}

const createValidator = () => {
  const form = document.querySelector("form")

  if (form === null) return () => undefined

  const submit = document.querySelector("[type='submit']")
  submit.disabled = toggleSubmitButton

  const onChange = () => {
    toggleSubmitButton()
  }
  form.addEventListener("change", onChange)

  return () => {
    form.removeEventListener("change", onChange)
  }
}

export default createValidator
